import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { profileIconImages } from "@/lib/constants";
import styles from "@/styles/Profile.module.scss";
import Image from "next/legacy/image";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconLock = function IconLock(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.75,5.833V3.5a3.5,3.5,0,0,0-7,0V5.833H3V14H13.5V5.833ZM8.833,10.338v1.328H7.667V10.338a1.167,1.167,0,1,1,1.167,0ZM5.917,5.833V3.5a2.333,2.333,0,1,1,4.667,0V5.833Z",
      transform: "translate(-3)",
      fill: "#252525"
    })
  }));
};
IconLock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.5",
  height: "14",
  viewBox: "0 0 10.5 14"
};
function ProfileIconImage(_ref) {
  let {
    icon,
    displayName,
    ownerProfile,
    needPasscode,
    onClick
  } = _ref;
  const path = profileIconImages[icon] || profileIconImages[1];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.icon,
    onClick: onClick,
    children: [ownerProfile && !needPasscode && /*#__PURE__*/_jsx("span", {
      className: styles.ownerLabel,
      children: "\u30AA\u30FC\u30CA\u30FC"
    }), !ownerProfile && needPasscode && /*#__PURE__*/_jsx("span", {
      className: styles.keyLabel,
      children: /*#__PURE__*/_jsx("span", {
        className: styles.lock,
        children: /*#__PURE__*/_jsx(IconLock, {})
      })
    }), ownerProfile && needPasscode && /*#__PURE__*/_jsxs("span", {
      className: styles.ownerAndKeyLabel,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.owner,
        children: "\u30AA\u30FC\u30CA\u30FC"
      }), /*#__PURE__*/_jsx("span", {
        className: styles.lock,
        children: /*#__PURE__*/_jsx(IconLock, {})
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.image,
      children: !!path && /*#__PURE__*/_jsx(Image, {
        src: path,
        alt: displayName,
        layout: "fill"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.name,
      children: displayName
    })]
  });
}
export default /*#__PURE__*/memo(ProfileIconImage);